import { useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";

import { router } from "@/routes";
import { bindLoginNavigation } from "@/store";
import { bootstrapAtom } from "@/store/auth";
import { runBootstrapAtom } from "@/store/bootstrap";

/** 根组件：应用 bootstrap + 路由 */
const App = () => {
  /** bootstrap 状态，idle 时需触发首次加载 */
  const status = useAtomValue(bootstrapAtom).status;
  const runBootstrap = useSetAtom(runBootstrapAtom);

  /** 首次挂载：仅判断 guest / 是否需要恢复会话，登录成功由 bumpAuthSessionAtom 触发 */
  useEffect(() => {
    if (status === "idle") {
      void runBootstrap();
    }
  }, [status, runBootstrap]);

  /** 绑定 axios 401 等场景的 SPA 登录导航 */
  useEffect(() => {
    bindLoginNavigation((redirectUrl) => {
      const search =
        redirectUrl && !redirectUrl.includes("login")
          ? `?redirectUrl=${encodeURIComponent(redirectUrl)}`
          : "";
      void router.navigate(`/login${search}`, { replace: true });
    });
  }, []);

  return <RouterProvider router={router} />;
};

export default App;
